import React from "react";
import { useNavigate } from "react-router-dom";
import LoginPage from "../Login/LoginPage";
import aventiorLogo from "../../../assets/png/aventior_logo_color_white-new.png";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./landingPage.scss";

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="logInImg">
      <Grid container className="loginFormWrapper">
        <Grid item sm={6} md={4}>
          <Box>
            <LoginPage navigate={navigate} />
          </Box>
          <Box className="logInImg-wrap">
            <div className="logoWrap">
              <img src={aventiorLogo} alt="Aventior Logo" />
            </div>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default LandingPage;
